export default {"src":"/_next/static/media/blog-tag-icon.649d414e.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};